import { ITableHeader } from '@base/@types/components/Layout/TableGrid'
import { IParamsToSend } from '@base/@types/providers/Kpi/StorageProvider'

export const parseStorageKpiExportData = (
  headers: ITableHeader[],
  paramsToSend: IParamsToSend
) => {
  const headerFormatted = {
    configuracaoGrid: {
      centroCodigo: headers[0].columns[0]?.show,

      centroNome: false,

      centroTipo: headers[0].columns[1]?.show,

      gerenteCategoria: headers[1].columns[0]?.show,
      gerenteProduto: headers[1].columns[1]?.show,

      mundoCodigo: headers[2].columns[0]?.show,
      mundoNome: headers[2].columns[1]?.show,

      categoriaCompactaCodigo: headers[3].columns[0]?.show,
      categoriaCompactaNome: headers[3].columns[1]?.show,

      categoriaCodigo: headers[4].columns[0]?.show,
      categoriaNome: headers[4].columns[1]?.show,

      status: headers[5].columns[0]?.show,

      curvaABC: headers[6].columns[0]?.show,

      fornecedorCodigo: false,
      fornecedorNome: false,

      empresaCodigo: headers[8].columns[0]?.show,
      empresaNome: headers[8].columns[1]?.show,

      estoqueDisponivelRS: true,
      estoquePedidoRS: true,
      estoqueReservaRS: true,
      estoqueExcedidoRS: true,
      estoqueEscassoRS: true,

      estoqueDisponivelDias: headers[10].columns[0]?.show,
      estoquePedidoDias: headers[10].columns[1]?.show,
      estoqueReservaDias: headers[10].columns[2]?.show,
      estoqueExcedidoDias: headers[10].columns[3]?.show,
      estoqueEscassoDias: headers[10].columns[4]?.show,

      rupturaPercentual: true,
      estoqueEscasso: true,

      margemRS: headers[12].columns[0]?.show,
      estoqueMedio: headers[12].columns[1]?.show,
      gmroi: headers[12].columns[2]?.show
    }
  }

  return {
    ...paramsToSend,
    ...headerFormatted
  }
}
